import React from 'react';

import { Form, FormItemProps, Select } from 'antd';
import { t } from 'i18next';

import { CourtType } from '../store/types';
import { courtTypesList, courtTypesTittle } from '../utils/const';

type Props = FormItemProps;

export const SelectCourtType = ({ ...formProps }: Props) => (
  <Form.Item
    label={t('table.type')}
    name="type"
    {...formProps}
  >
    <Select<CourtType>>
      {courtTypesList.map((type) => (
        <Select.Option key={type} value={type}>
          {courtTypesTittle[type] ?? type}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
);
